import React, {useState} from "react";
import {
    Input,
    Popover,
    PopoverHandler,
    PopoverContent,
    Typography,
    Card,
    CardHeader,
    CardBody,
    Avatar,
    Progress,
    Menu,
    MenuHandler,
    IconButton,
    MenuList,
    MenuItem,
} from "@material-tailwind/react";
import { format } from "date-fns";
import { DayPicker } from "react-day-picker";
import {ChevronRightIcon, ChevronLeftIcon, EllipsisVerticalIcon} from "@heroicons/react/24/outline";
import {projectsTableData, statisticsChartsData} from "../../../data";
import {StatisticsChart} from "../../../widgets/charts";
import {ClockIcon} from "@heroicons/react/24/solid";
import SideNavUx from "../../layout/sidenav";
import NavBarUx from "../../layout/navbar";
import FooterUx from "../layout/footer_ux";

const ReportesUx = () => {
    const [initDate, setInitDate] = useState(null)
    const [finalDate, setFinalDate] = useState(null)
    const [openSidenav, setOpenSidenav] = useState(false);
    const routes = {main: 'Reportes', current: 'Reportes'}

    return (
        <>
            {/*<SideNavUx setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
            <div className="p-4 xl:ml-80">
                <NavBarUx routes={routes} setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>*/}
                <div className="min-h-screen p-8">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">
                            Reportes y Estadísticas de Ingresos y Movimientos
                        </h1>
                        <p className="text-gray-600">Consulta y analiza los datos.</p>
                    </div>
                    <div className="align-middle mb-8">
                        <div className="grid grid-cols-1">
                            <button
                                onClick={() => {
                                    window.location.href = "/print_delivery_report";
                                }}
                                type="button"
                                className="w-full px-4 py-2 text-white bg-green-500 hover:bg-green-600 rounded-md shadow focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
                            >
                                Imprimir Reporte
                            </button>
                        </div>
                    </div>
                    <div className="align-middle mb-8">
                        <div className="grid  lg:grid-cols-3 sm:grid-cols-1 gap-3 mb-3 items-end">
                            {/* Fecha Inicio */}
                            <div className="col-span-1">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Fecha Inicio
                                </label>
                                <input
                                    type="date"
                                    className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            {/* Fecha Fin */}
                            <div className="col-span-1">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Fecha Fin
                                </label>
                                <input
                                    type="date"
                                    className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>

                            {/* Buscar por Texto */}
                            <div className="col-span-1 lg:grid-cols-3">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Buscar por Texto
                                </label>
                                <input
                                    type="text"
                                    placeholder="Buscar ingreso, movimiento..."
                                    className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>

                        {/* Button */}
                        <div className="grid grid-cols-1">
                            <button
                                type="button"
                                className="w-full px-4 py-2 text-white bg-blue-500 hover:bg-blue-600 rounded-md shadow focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
                            >
                                Buscar
                            </button>
                        </div>
                    </div>


                    <hr className="my-6 border-blueGray-300"/>

                    <div className="mt-12">
                        <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                            <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                                <CardHeader
                                    floated={false}
                                    shadow={false}
                                    color="transparent"
                                    className="m-0 flex items-center justify-between p-6"
                                >
                                    <div>
                                        <Typography variant="h6" color="blue-gray" className="mb-1">
                                            Cobros
                                        </Typography>
                                    </div>
                                </CardHeader>
                                <CardBody className="overflow-x-scroll px-0 pt-0 pb-2">
                                    <table className="w-full min-w-[640px] table-auto">
                                        <thead>
                                        <tr>
                                            {["Folio", "Clave", "Forma de pago", "Total", "Fecha"].map(
                                                (el) => (
                                                    <th
                                                        key={el}
                                                        className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                    >
                                                        <Typography
                                                            variant="small"
                                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                        >
                                                            {el}
                                                        </Typography>
                                                    </th>
                                                )
                                            )}
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {projectsTableData.map(
                                            ({img, name, members, budget, completion}, key) => {
                                                const className = `py-3 px-5 ${
                                                    key === projectsTableData.length - 1
                                                        ? ""
                                                        : "border-b border-blue-gray-50"
                                                }`;

                                                return (
                                                    <tr key={name}>
                                                        <td className={className}>
                                                            <div className="flex items-center gap-4">
                                                                <Typography
                                                                    variant="small"
                                                                    color="blue-gray"
                                                                    className="font-bold"
                                                                >
                                                                    {name}
                                                                </Typography>
                                                            </div>
                                                        </td>
                                                        <td className={className}>
                                                            <Typography
                                                                variant="small"
                                                                className="text-xs font-medium text-blue-gray-600"
                                                            >
                                                                {budget}
                                                            </Typography>
                                                        </td>
                                                        <td className={className}>
                                                            <Typography
                                                                variant="small"
                                                                className="text-xs font-medium text-blue-gray-600"
                                                            >
                                                                14/12/2024
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                        </tbody>
                                    </table>
                                </CardBody>
                            </Card>
                        </div>
                    </div>

                    <hr className="my-6 border-blueGray-300"/>

                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                        {statisticsChartsData.map((props) => (
                            <StatisticsChart
                                key={props.title}
                                {...props}
                                footer={
                                    <Typography
                                        variant="small"
                                        className="flex items-center font-normal text-blue-gray-600"
                                    >
                                        <ClockIcon
                                            strokeWidth={2}
                                            className="h-4 w-4 text-blue-gray-400"
                                        />
                                        &nbsp;{props.footer}
                                    </Typography>
                                }
                            />
                        ))}
                    </div>

                </div>
            {/*<FooterUx/>
            </div>*/}
        </>
    );
};

export default ReportesUx;

